import React from 'react';
import PropTypes from 'prop-types';
import { HeadingText } from '@paypalcorp/pp-react';
import getLocaleMessages from '../../utils/localesMessages';
import ButtonPreviewContainer from './ButtonPreviewContainer';

const { previewContainerHeader } = getLocaleMessages('buttonsV3/buttonPreview');

const WizardStep1Preview = ({
  usePaypalButtonStyle,
  buttonSize,
  showAcceptedCardLogos,
  buttonImageUrl,
  onError,
  locale,
  country,
  isMobile,
}) => {
  return (
    <div className="preview-step-one">
      {!isMobile ? (
        <HeadingText size="sm" className="preview-step-one-heading">
          {previewContainerHeader}
        </HeadingText>
      ) : null}
      <div className="preview-renderer">
        <div className="skeleton-wrapper">
          <div className="skeleton-screen-header">
            <div className="skeleton-logo-container">
              <div className="skeleton-logo-radial btn-preview-v3"></div>
              <div className="skeleton-logo-linear btn-preview-v3"></div>
            </div>
            <div className="skeleton-link-container">
              <div className="skeleton-link btn-preview-v3"></div>
              <div className="skeleton-link btn-preview-v3"></div>
              <div className="skeleton-link btn-preview-v3"></div>
            </div>
          </div>

          <div className="skeleton-content-container">
            <div className="btn-overview-skel-banner btn-preview-v3"></div>
            <div className="donate-button-preview">
              <ButtonPreviewContainer
                usePaypalButtonStyle={usePaypalButtonStyle}
                buttonSize={buttonSize}
                showAcceptedCardLogos={showAcceptedCardLogos}
                buttonImageUrl={buttonImageUrl}
                onError={onError}
                locale={locale}
                country={country}
              />
            </div>
            <div className="skeleton-content margin-top-24">
              <div className="skeleton-content-left margin-right-16">
                <div className="skeleton-content">
                  <div className="btn-preview-skel-lt-lg  btn-preview-v3"></div>
                  <div className="btn-preview-skel-lt-articles">
                    <div className="btn-preview-skel-lt-article  btn-preview-v3"></div>
                    <div className="btn-preview-skel-lt-article  btn-preview-v3"></div>
                    <div className="btn-preview-skel-lt-article  btn-preview-v3"></div>
                  </div>
                </div>
              </div>
              <div className="skeleton-content-right">
                <div className="skeleton-right-article">
                  <div className="skeleton-rt-article-lg  btn-preview-v3"></div>
                  <div className="skeleton-rt-articles">
                    <div className="skeleton-rt-article  btn-preview-v3"></div>
                    <div className="skeleton-rt-article  btn-preview-v3"></div>
                    <div className="skeleton-rt-article  btn-preview-v3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="skeleton-logo-linear-headline"></div>
          <div className="btn-overview-skel-banner btn-preview-v3"></div>
        </div>
      </div>
    </div>
  );
};

WizardStep1Preview.propTypes = {
  usePaypalButtonStyle: PropTypes.bool,
  buttonSize: PropTypes.string,
  showAcceptedCardLogos: PropTypes.bool,
  buttonImageUrl: PropTypes.string,
  onError: PropTypes.func,
  locale: PropTypes.string,
  country: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default WizardStep1Preview;
